import type { Classification } from '@yes.technology/react-toolkit'
import { useMemo } from 'react'

import type { StatusAction } from 'status/shared/situation.type'

import {
  computeTaskStatusActions,
  TaskStatusActionsResult
} from './computeTaskStatusActions'

export { computeTaskStatusActions } from './computeTaskStatusActions'
export type {
  StatusActionClassificationInput,
  TaskStatusActionsResult
} from './computeTaskStatusActions'

export default function useTaskStatusActions(
  statusActions: StatusAction[],
  classification?: Classification
): TaskStatusActionsResult<StatusAction> {
  return useMemo(
    () => computeTaskStatusActions(statusActions, classification),
    [statusActions, classification]
  )
}
